module.exports = __webpack_public_path__ + "images/logo-white_fec4f773384b4cc5dbfb689669d5eedb.png";